const themeStyles = colors => {
  const styles = {
    dataTitle: {
      color: colors.approxBlack,
      fontSize: 14,
      marginBottom: 6,
      lineHeight: '20px'
    }
  }
  return styles
}

export default themeStyles
